import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, MessageCircle } from "lucide-react";
import { CONTACT } from "@/data/content";

const whatsappUrl = `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent("Hi SML Municipal Consulting, I'd like assistance with my municipal account.")}`;

export const FloatingActions = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      {/* Floating WhatsApp (desktop + mobile) */}
      <AnimatePresence>
        {show && (
          <motion.a
            href={whatsappUrl} target="_blank" rel="noopener noreferrer" data-testid="floating-whatsapp"
            aria-label="Contact us on WhatsApp"
            initial={{ opacity: 0, scale: 0.6 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.6 }}
            className="fixed z-40 right-5 bottom-24 md:bottom-6 flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_-6px_rgba(37,211,102,0.6)] hover:scale-105 transition-transform"
          >
            <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" />
            <MessageCircle className="w-7 h-7 relative" />
          </motion.a>
        )}
      </AnimatePresence>

      {/* Mobile sticky bottom bar: Call + Request Quote */}
      <div className="lg:hidden fixed z-40 inset-x-0 bottom-0 bg-white/95 backdrop-blur-lg border-t border-slate-200 px-3 py-2.5 flex gap-2.5" data-testid="mobile-sticky-cta">
        <a
          href={`tel:${CONTACT.phoneRaw}`} data-testid="sticky-call"
          className="flex-1 inline-flex items-center justify-center gap-2 rounded-full border border-slate-200 py-3 font-semibold text-primary text-sm"
        >
          <Phone className="w-4 h-4" /> Call
        </a>
        <a
          href="#quote" data-testid="sticky-quote"
          className="flex-[1.4] inline-flex items-center justify-center gap-2 rounded-full bg-secondary text-white py-3 font-semibold text-sm shadow"
        >
          Request a Quote
        </a>
      </div>
    </>
  );
};
